import React, { useState } from "react";

const Tooltip = ({
  children,
  content,
  position = "top",
  tooltipStyle = {},
  containerStyle = {},
  className = "",
  background = "#222",
  boxShadow = "#a3c8e3",
}) => {
  const [visible, setVisible] = useState(false);

  const getPositionStyle = () => {
    const positions = {
      top: {
        bottom: "calc(100% + 10px)",
        left: "50%",
        transform: visible
          ? "translateX(-50%) scale(1)"
          : "translateX(-50%) scale(0.95)",
      },

      bottom: {
        top: "calc(100% + 10px)",
        left: "50%",
        transform: visible
          ? "translateX(-50%) scale(1)"
          : "translateX(-50%) scale(0.95)",
      },

      left: {
        right: "calc(100% + 10px)",
        top: "50%",
        transform: visible
          ? "translateY(-50%) scale(1)"
          : "translateY(-50%) scale(0.95)",
      },

      right: {
        left: "calc(100% + 10px)",
        top: "50%",
        transform: visible
          ? "translateY(-50%) scale(1)"
          : "translateY(-50%) scale(0.95)",
      },

      "left-top": {
        right: "calc(100% + 10px)",
        top: 0,
      },

      "left-bottom": {
        right: "calc(100% + 10px)",
        bottom: 0,
      },

      "right-top": {
        left: "calc(100% + 10px)",
        top: 0,
      },

      "right-bottom": {
        left: "calc(100% + 10px)",
        bottom: 0,
      },
    };

    return positions[position] || positions.top;
  };

  return (
    <div
      className={className}
      style={{
        position: "relative",
        display: "inline-block",
        ...containerStyle,
      }}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}

      <div
        style={{
          position: "absolute",
          zIndex: 9999,
          width: "fit-content",
          padding: "10px 14px",
          borderRadius: "8px",
          background: background,
          color: "#fff",
          fontSize: "13px",
          boxShadow: boxShadow,
          pointerEvents: "none",
          opacity: visible ? 1 : 0,
          visibility: visible ? "visible" : "hidden",
          transition: "all 0.2s ease",
          ...getPositionStyle(),
          ...tooltipStyle,
        }}
      >
        {content}
      </div>
    </div>
  );
};

export default Tooltip;
